import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import {StoreContext} from "../../stores/contexts";

class CheckAll extends Component {
  static contextType = StoreContext;

  render() {
    return (

        <label>
          <input type="checkbox" onChange={(e)=>{
            if(e.target.checked) {
              this.context.selectStore.selectAll();
            } else {
              this.context.selectStore.unselectAll();
            }
          }} value="1" /><span></span>
        </label>

    )
  }
}

// export default inject("selectStore")(observer(CheckAll));
export default observer(CheckAll);